import { useEffect, useState } from 'react';
import Select from 'react-select';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { GetScanningElementList } from '../../../../store/FLEET/FleetScan/fleetScanSlice';
import { useFormik } from 'formik';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody, CardHeader } from '../../../../components/card/card';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
  GetPeriodicallyScanningById,
  UpdatePeriodicallyScanning
} from '../../../../store/FLEET/EquipmentInspection/equipmentInspectionSlice';
import Button from 'react-bootstrap/Button';
import PopoverCustom from '@components/Shared/Popover/PopoverCustom';
import { AddFleetInspectionSchema } from '../../../ValidationForm/validationSchema';
// import { AddPeriodicallyScanning } from '../../../../store/FLEET/EquipmentInspection/equipmentInspectionSlice';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { useNavigate, useParams } from 'react-router-dom';
import useGetEquipmentsList from '../../../../hooks/FLeet/useGetEquipmentsList';
import Loading from '../../../../components/Shared/Loader/Loading';

import Kuroki from '../Kuroki';
import FileUpload from '@components/Files/FileUpload';
import useGetPeoplesList from '@hooks/NTX/useGetPeoplesList';

const UpdateScan = () => {
  const [attachments, setAttachments] = useState<any[]>([]);

  const [date, setDate] = useState('');
  const Navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { fleetEquipmentsId, id } = useParams();

  const { OptionsDrivers } = useGetPeoplesList({ LookupType: '' });

  const { EquipmentsList, OptionsEquipments } = useGetEquipmentsList();
  const { ScanElementList, loading } = useAppSelector(state => state.FleetScan);
  const EquipmentData = EquipmentsList?.find(f => f.id === fleetEquipmentsId);
  const { PeriodicallyScanningById: data } = useAppSelector(state => state.EquipmentInspection);

  useEffect(() => {
    // Set the initial date to today
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    setDate(formattedDate);
  }, []);

  useEffect(() => {
    dispatch(GetScanningElementList({ modelId: EquipmentData?.fleetModelId }));
  }, [dispatch, EquipmentData]);

  useEffect(() => {
    if (id) {
      dispatch(GetPeriodicallyScanningById(id));
    }
  }, [id]);

  useEffect(() => {
    if (Array.isArray(data?.attachment) && data.attachment.length > 0) {
      const attachmentsList = data.attachment.map(item => ({
        name: item.fileName || '',
        url: item.filePath || ''
      }));
      setAttachments(attachmentsList);
    } else {
      setAttachments([]);
    }
  }, [data]);

  const formik = useFormik({
    initialValues: {
      id: data ? data?.id : null,
      fleetEquipmentsId: fleetEquipmentsId,
      driverId: data ? data?.driverId : '',
      scanningCode: data ? data?.scanningCode : '',
      lookupType: data ? data?.lookupType : '',
      scanningDate: data ? data?.scanningDate : date,
      description: data ? data?.description : '',
      odometer: data ? data?.odometer : '',
      attachments: data ? data?.attachment : [],
      IsUpdateAttach: false,
      details: data
        ? data?.details?.map(item => ({
            // scanningMasterId: null,
            id: item.id,
            scanningElementId: item.scanningElementId,
            value: item.value,
            description: item.elementName
          }))
        : [],
      markers: data?.markers?.map(item => ({
        id: item.id,
        x: item.xPosition,
        y: item.yPosition,
        shape: item.shape,
        color: item.color,
        comment: item.comment,
        size: item.size
      }))
    },
    enableReinitialize: true,
    validationSchema: AddFleetInspectionSchema(t),
    onSubmit: values => {
      const formData = new FormData();
      formData.append('Id', values.id?.toString() ?? '');
      formData.append('FleetEquipmentsId', fleetEquipmentsId?.toString() ?? '');
      formData.append('DriverId', values.driverId || '');
      formData.append('ScanningCode', values.scanningCode || '');
      formData.append('LookupType', values.lookupType || '');
      formData.append('ScanningType', '');
      formData.append('ScanningDate', values.scanningDate || '');
      formData.append('Description', values.description || '');

      // Append details to formData
      values.details.forEach((detail, index) => {
        formData.append(`Details[${index}].id`, detail.scanningElementId);
        formData.append(`Details[${index}].scanningElementId`, detail.scanningElementId);
        formData.append(`Details[${index}].value`, detail.value === true ? 'true' : 'false');
        // formData.append(`Details[${index}].Value`, detail.value === '1' ? 'true' : 'false');

        formData.append(`Details[${index}].description`, detail.description);
      });

      // Append Markers to formData
      if (Array.isArray(values.markers)) {
        values.markers.forEach((marker: any, index) => {
          formData.append(`Markers[${index}].id`, marker.id?.toString() ?? '');
          formData.append(`Markers[${index}].xPosition`, marker.x?.toString() ?? '');
          formData.append(`Markers[${index}].yPosition`, marker.y?.toString() ?? '');
          formData.append(`Markers[${index}].shape`, marker.shape ?? '');
          formData.append(`Markers[${index}].color`, marker.color ?? '');
          formData.append(`Markers[${index}].comment`, marker.comment ?? '');
          formData.append(`Markers[${index}].size`, marker.size?.toString() ?? '');
        });
      }

      formData.append('IsUpdateAttach', values.IsUpdateAttach ? 'true' : 'false');

      // رفع المرفقات
      if (values.attachments && values.attachments.length > 0) {
        values.attachments.forEach((file: any) => {
          formData.append('attach', file); // file من نوع File أو Blob
        });
      }

      dispatch(UpdatePeriodicallyScanning(formData))
        .unwrap()
        .then(res => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Edit' });
            if (id) {
              dispatch(GetPeriodicallyScanningById(id));
            }
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  const handleAttachments: React.Dispatch<React.SetStateAction<File[]>> = value => {
    setAttachments(prev => {
      const newAttachments = typeof value === 'function' ? value(prev) : value;
      if (newAttachments.length > 0) {
        formik.setFieldValue('attachments', newAttachments);
        formik.setFieldValue('IsUpdateAttach', true);
      } else {
        formik.setFieldValue('attachments', []);
        formik.setFieldValue('IsUpdateAttach', false);
      }
      return newAttachments;
    });
  };

  //________________________________

  // console.log(formik.values.details);
  console.log(formik.values?.details);
  // console.log(data  ?.markers);

  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          { name: 'Home',link: ':moduleHome' },
          { name: 'EquipmentInspection', link: '/FLEET/EquipmentInspection' },
          { name: i18n.language === 'ar' ? EquipmentData?.name2 : EquipmentData?.name, link: null }
        ]}
        PageName='EquipmentInspection'
        subtitle={i18n.language === 'ar' ? EquipmentData?.name2 : EquipmentData?.name}
      />

      <Loading loading={loading}>
        <CardBody className=''>
          <Form onSubmit={formik.handleSubmit}>
            {/* Equipment Info Section sticky-top*/}

            <div
              className='row mb-4 '
              style={{
                backgroundColor: 'var(--bs-card-bg)',
                zIndex: 10,
                paddingTop: '10px',
                paddingBottom: '10px',
                boxShadow: '0 5px 4px rgba(0,0,0,0.1)'
              }}
            >
              <div className='col-md-12 mb-3'>
                <Card className='h-100 '>
                  <CardBody>
                    <div className='row'>
                      <div className='col-md-12'>
                        <div className='input-group flex-nowrap'>
                          <span className='input-group-text bg-theme text-white fw-bold'>
                            <i className='fas fa-car-side me-2'></i>
                            {t('Vehicle')}
                          </span>
                          <Select
                            isDisabled
                            classNamePrefix='react-select'
                            className='w-100  '
                            isLoading={loading}
                            isSearchable={true}
                            isClearable
                            options={OptionsEquipments.filter(f => !f.IsVacant)}
                            value={OptionsEquipments.find(f => f.value === fleetEquipmentsId)}
                            placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                            formatOptionLabel={option => {
                              const isRTL = i18n.language === 'ar';
                              const imgSrc = option.PathImage || '/assets/img/Image/NoImg2.ico';

                              return (
                                <div className='d-flex justify-content-between align-items-center'>
                                  <div className='d-flex align-items-center'>
                                    <img
                                      src={imgSrc}
                                      alt={option.label}
                                      onError={(e: any) => {
                                        e.target.onerror = null;
                                        e.target.src = '/assets/img/Image/NoImg2.ico';
                                      }}
                                      style={{
                                        width: '40px',
                                        height: '40px',
                                        objectFit: 'cover',
                                        marginLeft: isRTL ? '10px' : '0',
                                        marginRight: isRTL ? '0' : '10px',
                                        borderRadius: '4px'
                                      }}
                                    />
                                    <div>{option.label}</div>
                                  </div>
                                  {/* <span className='fw-bold badge border border-theme text-theme px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
                                    <i className='bi bi-person-fill fs-18px fa-fw me-5px'></i>
                                    {option.deiverName}
                                  </span> */}
                                </div>
                              );
                            }}
                          />
                        </div>
                      </div>

                      <div className='col-md-4 mt-3'>
                        <div className='input-group flex-nowrap'>
                          <span className='input-group-text bg-theme text-white fw-bold'>
                            <i className='fas fa-user fa-lg	 me-2'></i>
                            {t('Driver')}
                          </span>
                          <Select
                            isDisabled
                            classNamePrefix='react-select'
                            className='w-100  '
                            isLoading={loading}
                            isSearchable={true}
                            isClearable
                            options={OptionsDrivers}
                            value={OptionsDrivers.find(f => f.value === EquipmentData?.peopleId)}
                            placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                          />
                        </div>
                      </div>

                      <div className='col-md-4 mt-3'>
                        <div className='input-group flex-nowrap'>
                          <span className='input-group-text bg-theme text-white fw-bold'>
                            <i className=' fa-fw bi bi-speedometer fa-lg	 me-2'></i>
                            {t('Odometer')}
                          </span>
                          <Form.Control
                            type='number'
                            name='odometer'
                            value={formik.values.odometer || 0}
                            onChange={formik.handleChange}
                            className='form-control-lg'
                          />
                        </div>
                      </div>
                      <div className='col-md-4 mt-3'>
                        <div className='input-group flex-nowrap'>
                          <span className='input-group-text bg-theme text-white fw-bold'>
                            <i className='far fa-calendar-alt fa-lg me-2'></i>
                            {t('InspectionDate')}
                          </span>
                          <Form.Control
                            // type='datetime-local'
                            type='date'
                            name='scanningDate'
                            value={formik.values.scanningDate || ''}
                            onChange={formik.handleChange}
                            className='form-control-lg'
                          />
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </div>

            {/* Inspection Items Section */}
            <Card className='mb-4'>
              <CardHeader className='bg-theme bg-opacity-25 text-white'>
                <h5 className='mb-0'>
                  <i className='fas fa-clipboard-list me-2'></i>
                  {t('InspectionList')}
                </h5>
              </CardHeader>
              <CardBody>
                <div className='row'>
                  {data &&
                    data.details &&
                    data?.details
                      ?.slice()
                      .sort((a, b) => a.elementSort - b.elementSort)
                      ?.map((item, index) => {
                        const detail = formik.values.details?.[index] ?? {};

                        return (
                          <div key={index} className='col-md-4 mb-2'>
                            <div className='bg-inverse bg-opacity-10 rounded-2 p-2 border hover-highlight d-flex justify-content-between'>
                              <div className='fw-bold mb-0'>
                                <span className='me-2 text-theme '>{index + 1}.</span>
                                {i18n.language === 'en' ? item.elementName : item.elementName2}

                                {item.description && (
                                  <PopoverCustom
                                    childern={<i className='fas fa-info-circle ms-2'></i>}
                                    Body={i18n.language === 'en' ? item.elementDescription : item.elementDescription2}
                                  />
                                )}
                              </div>

                              <div className='text-center d-flex gap-2 justify-content-center'>
                                <Button
                                  variant={detail?.value === true ? 'success' : 'outline-success'}
                                  onClick={() => formik.setFieldValue(`details[${index}].value`, true)}
                                >
                                  <i className='fas fa-check '></i>
                                </Button>

                                <Button
                                  variant={detail?.value === false ? 'danger' : 'outline-danger'}
                                  onClick={() => formik.setFieldValue(`details[${index}].value`, false)}
                                >
                                  <i className='fas fa-times'></i>
                                </Button>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                </div>

                <style>
                  {`
                      .hover-highlight {
                        transition: background-color 0.3s ease, box-shadow 0.3s ease;
                      }
                    .hover-highlight:hover {
                     background-color: rgba(var(--bs-theme-rgb), 0.2) !important;
                     box-shadow: 0 0 5px rgba(0, 123, 255, 0.4);
                     cursor: pointer;
                    }

                      `}
                </style>
              </CardBody>
            </Card>

            {/* Diagram Section */}
            {ScanElementList?.kuroki && (
              <Card className='mb-4'>
                <CardHeader className='bg-theme bg-opacity-25 text-white'>
                  <h5 className='mb-0'>
                    <i className='fas fa-image me-2'></i>
                    {t('VehicleDiagram')}
                  </h5>
                </CardHeader>
                <CardBody>
                  <Kuroki formik={formik} KurokiImage={ScanElementList.kuroki.filePath ?? ''} />
                </CardBody>
              </Card>
            )}

            {/* Notes & Attachments Section */}
            <div className='row mb-2'>
              <div className='col-md-6 mb-3'>
                <Card className='h-100'>
                  <CardHeader className='bg-theme bg-opacity-25 text-white'>
                    <h5 className='mb-0'>
                      <i className='fas fa-edit me-2'></i>
                      {t('Notes')}
                    </h5>
                  </CardHeader>
                  <CardBody>
                    <Form.Control
                      as='textarea'
                      rows={5}
                      name='description'
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      placeholder={t('AddYourNotesHere')}
                      className='h-100'
                    />
                  </CardBody>
                </Card>
              </div>

              <div className='col-md-6 mb-3'>
                <Card className='h-100'>
                  <CardHeader className='bg-theme bg-opacity-25 text-white'>
                    <h5 className='mb-0'>
                      <i className='fas fa-paperclip me-2'></i>
                      {t('Attachments')}
                    </h5>
                  </CardHeader>
                  <CardBody>
                    <FileUpload attachments={attachments} setAttachments={handleAttachments} />
                  </CardBody>
                </Card>
              </div>
            </div>

            {/* Action Buttons */}

            <div className='d-flex justify-content-center gap-3 mt-1'>
              <button
                type='submit'
                className='btn btn-lg  btn-theme mb-1 w-100 rounded-0'
                disabled={formik.isSubmitting}
              >
                {formik.isSubmitting ? (
                  <>
                    <span className='spinner-border spinner-border-sm me-2'></span>
                    {t('Saving')}...
                  </>
                ) : (
                  <>
                    <i className='fas fa-save me-2'></i>
                    {t('Save')}
                  </>
                )}
              </button>

              <button
                type='button'
                className='btn btn-lg  btn-default mb-1 w-100 rounded-0'
                onClick={() => Navigate(-1)}
              >
                <i className='fas fa-times me-2'></i>
                {t('Cancel')}
              </button>
            </div>
          </Form>
        </CardBody>
      </Loading>
    </>
  );
};

export default UpdateScan;
